import React, { useContext } from 'react'
import BiddingButtons from '@components/BiddingButtons'
import BidButton from '../../../../elements/BidButton/BidButton'
import { ItemCardManger } from '@components/Cards/BidItem'
import { AuthContext } from '../../../../contexts/AuthContext'
import LoginRedirect from '@components/LoginRedirect'
import _isNumber from 'lodash/isNumber'

const Buttons = ({ loadingBid, setLoadingBid }: any) => {
  const {
    item,
    offers = [],
    item: {
      id,
      auctionId,
      itemClosed,
      bidsEnabled,
      binEnabled,
      binPaid,
      maoEnabled,
      removed,
      binPrice,
    },
    itemHandler: { updateItem },
    handlers: { handleBtnClick, setModalData, setModalAction, toggleModal },
    options: { isBidsPage, isSavedSearchPage, isSimplified },
    location,
  } = useContext<any>(ItemCardManger)
  const {
    isAuthenticated,
    isLoading,
    userData: {
      profile: { isAddedCard },
    },
  } = useContext<any>(AuthContext)

  if (isSimplified) return <></>

  const offerMade = offers && offers.includes(id)

  if (isLoading)
    return (
      <div className={'flex flex-col gap-2'}>
        <div />
        <div className={'animate-pulse w-full h-11 bg-slate-400 rounded-md'} />
        <div className={'animate-pulse w-full h-11 bg-slate-200 rounded-md'} />
      </div>
    )

  return (
    <>
      {!itemClosed && !removed && (bidsEnabled || isBidsPage) && (
        <BiddingButtons
          item={item}
          updateItem={updateItem}
          auctionId={auctionId}
          auctionTypeId={item?.auctionTypeId}
          loadingBid={loadingBid}
          setLoadingBid={setLoadingBid}
          toggleModal={toggleModal}
          setModalAction={setModalAction}
          setModalData={setModalData}
          location={location}
        />
      )}
      {(binEnabled || maoEnabled) &&
        (isAuthenticated ? (
          !isAddedCard ? (
            <BidButton
              label="Add Card To Bid"
              theme="blue-light"
              link="/account/dashboard/cards"
              type="link"
              width="full"
            />
          ) : isSavedSearchPage ? (
            <BidButton
              label="View Item"
              theme="blue-light"
              type="link"
              link={`/${auctionId}/item-detail/${id}`}
              width="full"
            />
          ) : (
            <div className="mt-3 grid gap-2">
              <div
                className={`${
                  !binEnabled || binPaid || itemClosed ? 'hidden' : ''
                }`}
              >
                <BidButton
                  label={`Buy It Now $${
                    _isNumber(binPrice) ? binPrice.toFixed(2) : ''
                  }`}
                  theme="blue-light"
                  callBack={(e: any) => {
                    e.stopPropagation()
                    handleBtnClick('bin')
                  }}
                  width="full"
                />
              </div>
              <div className={`${!maoEnabled || offerMade ? 'hidden' : ''}`}>
                <BidButton
                  label="Make an Offer"
                  theme="blue"
                  callBack={(e: any) => {
                    e.stopPropagation()
                    handleBtnClick('mao')
                  }}
                  width="full"
                />
              </div>
            </div>
          )
        ) : (
          <LoginRedirect />
        ))}
    </>
  )
}

export default Buttons
